import * as styles from '@rdcomponents/navigation/quick-search/quick-search-modal.scss';
import type {SearchableMenuItemType} from '@rdcomponents/navigation/quick-search/use-searchable-menu-items';

import {classNames} from '../../../util/css';

type PropsType = {
    item: SearchableMenuItemType;
    isSelected: boolean;
    onClick: (item: SearchableMenuItemType) => void;
    onRef: (element: HTMLButtonElement | null) => void;
};

export function SearchResultItem(props: PropsType): JSX.Element {
    const {item, isSelected, onClick, onRef} = props;

    return (
        <li className={styles.QuickSearchModal_item} key={item.path}>
            <button
                className={classNames(styles.QuickSearchModal_itemButton, {
                    [styles.QuickSearchModal_itemButton_selected]: isSelected,
                })}
                onClick={() => onClick(item)}
                ref={onRef}
                type="button"
            >
                {item.icon && <span className={styles.QuickSearchModal_itemIcon}>{item.icon}</span>}
                <span className={styles.QuickSearchModal_itemLabel}>{item.displayLabel}</span>
            </button>
        </li>
    );
}
